(function() { window.GUID_6ee5ce80_79fa_4ff7_b1ca_4e83a7ee239f = { getGuid: function() { return "6ee5ce80-79fa-4ff7-b1ca-4e83a7ee239f"; } }; })();
var CS;
(function (CS) {
    class SignalRHelper {
        static get Instance() {
            if (!SignalRHelper.instance) {
                SignalRHelper.instance = new SignalRHelper();
            }
            return SignalRHelper.instance;
        }
        get ConnectionId() {
            var _a;
            return (_a = this.connection) === null || _a === void 0 ? void 0 : _a.connectionId;
        }
        constructor() {
            this.startCallbacks = [];
            this.SignalRStartedEvent = "signalrstarted";
            this.Logging = false;
            let me = this;
            me.reconnectAttemptTimer = null;
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl("/signalr")
                .configureLogging(this.Logging ? signalR.LogLevel.Information : signalR.LogLevel.None)
                .withAutomaticReconnect()
                .build();
            this.connection.onreconnecting(error => {
                if (this.Logging) {
                    console.log('SignalR reconnecting', error);
                }
                //clearInterval(this.reconnectAttemptTimer);
            });
            this.connection.onreconnected(connectionId => {
                if (this.Logging) {
                    console.log('SignalR reconnected', connectionId);
                }
                $('body').trigger(this.SignalRStartedEvent, [true]);
            });
            this.connection.onclose(error => {
                if (this.Logging) {
                    console.log('SignalR disconnected', error);
                }
                this.tryManualReconnect();
            });
        }
        tryManualReconnect() {
            let delay = 2000;
            const attempt = () => {
                if (this.connection.state !== signalR.HubConnectionState.Disconnected) {
                    return;
                }
                this.connection.start()
                    .then(() => {
                    console.info("Manual reconnect succeeded");
                    $('body').trigger(this.SignalRStartedEvent, [true]);
                })
                    .catch(err => {
                    console.warn("Manual reconnect failed", err);
                    delay = Math.min(delay * 1.5, 15000);
                    setTimeout(attempt, delay);
                });
            };
            setTimeout(attempt, delay);
        }
        StartConnection(startCallback) {
            let me = this;
            if (me.Logging) {
                console.info('SignalR - StartConnection');
            }
            if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                this.connection.start()
                    .then(() => {
                    this.notifyCallers(startCallback);
                })
                    .catch(err => {
                    console.error(err);
                });
            }
            else if (this.connection.state === signalR.HubConnectionState.Connected) {
                clearInterval(this.reconnectAttemptTimer);
                this.notifyCallers(startCallback);
            }
        }
        notifyCallers(startCallback, isReconnect = false) {
            if (startCallback) {
                startCallback.call(SignalRHelper.Instance, isReconnect);
            }
            else {
                if (this.Logging) {
                    console.info('SignalR - trigger all callbacks');
                }
                $('body').trigger(this.SignalRStartedEvent, [isReconnect]);
            }
        }
        Start(namespace, startCallback) {
            let me = this;
            $('body').off(this.SignalRStartedEvent + "." + namespace);
            if (startCallback) {
                $('body').on(this.SignalRStartedEvent + "." + namespace, function (event, ...args) {
                    startCallback.apply(this, args);
                });
            }
            me.StartConnection(startCallback);
        }
        Stop(namespace, hubDisconectMethod, methodParameter) {
            let me = this;
            //clearInterval(me.reconnectAttemptTimer);
            if (this.Logging) {
                console.info('SignalR - Stopping - ' + namespace);
                if (hubDisconectMethod) {
                    console.info('          and invoking ' + hubDisconectMethod);
                }
            }
            if (namespace) {
                $('body').off(this.SignalRStartedEvent + "." + namespace);
            }
            if (hubDisconectMethod) {
                me.Invoke(hubDisconectMethod, null, methodParameter);
            }
            if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
                this.connection.stop();
            }
        }
        Invoke(methodName, callback, ...args) {
            if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                this.StartConnection(() => {
                    this.connection.invoke(methodName, ...args)
                        .then(result => {
                        callback === null || callback === void 0 ? void 0 : callback.call(this, result);
                    })
                        .catch(err => {
                        if (this.Logging) {
                            console.error(err);
                        }
                    });
                });
            }
            else {
                this.connection.invoke(methodName, ...args)
                    .then(result => {
                    callback === null || callback === void 0 ? void 0 : callback.call(this, result);
                })
                    .catch(err => {
                    if (this.Logging) {
                        console.error(methodName + " " + err);
                    }
                });
            }
        }
        Receive(name, callback) {
            if (!this.connection) {
                return;
            }
            this.connection.off(name);
            this.connection.on(name, callback);
        }
    }
    CS.SignalRHelper = SignalRHelper;
})(CS || (CS = {}));

//# sourceMappingURL=cs-signalr.js.map
